<template>
    <div class="latest-news">
        <div class="title">
            <h3>ùltimos Comentários dos diretores</h3>
        </div>
        <div class="published-news">
            <div class="news" v-for="(comment, index) in noticias" :key="index">
                <div class="news-wrapper">
                    <img class="news-image" :src="getFirstActveImage(comment.imagens)" alt="Imagem">
                    <div class="news-container">
                        <div class="news-text">
                            <h3 class="text">
                                {{ comment.titulo }}
                            </h3>
                            <p v-html="comment.noticia.substring(0, 400)" v-if="comment.noticia.length > 0"></p>
                        </div>
                        <a :href="comment.id" class="leia-mais">Leia mais...</a>
                    </div>
                </div>
                <p class="autor">por<span> Comentários do Diretor  </span>{{comment.data_noticia}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ImagensMixin from '../../../../mixins/images.mixin'
export default {
    name: "latest-comments",
    mixins: [ImagensMixin],
    props: ['noticias'],
}
</script>

<style scoped lang="scss">
.latest-news {
    .title {
        border-bottom: 3px solid #e6242c;
        h3 {
            @apply font-extrabold text-black uppercase text-xl;
        }
    }
    .published-news {
        @apply flex justify-between py-8 px-0;

        @media (max-width: 768px) {
            @apply flex-col;
        }

        .leia-mais {
            @apply text-black italic font-black;

            &:hover {
                @apply text-secondary;
            }
        }

        .news {
            @apply flex flex-col justify-between  border-r-2 border-light-gray  pr-5 pl-5;
            width: calc(100% / 4);
            @media (max-width: 768px) {
                width: 100%;
                padding: 0;
                border: none;
            }
            .autor {
                align-content: flex-end;
                @apply text-right text-sm;
                span {
                    @apply text-tertiary text-sm;
                }
            }
        }
        .news-wrapper{
            @apply w-full flex flex-col;
            @media (max-width: 768px) {
                @apply w-full my-4;
            }
            .news-image {
                background: #fed843;
                width: 100%;
                height: 250px;
                object-fit: cover;
                border-radius: 10px;
            }
            .news-container {
                p {
                    @apply text-sm mb-5;
                }
                h3 {
                    @apply my-5;
                }
            }
            .fonte {
                @apply text-right;
                span {
                    @apply text-tertiary;
                }
            }
            .news-text {
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 15;
                -webkit-box-orient: vertical;
            }
            a {
                @apply text-black font-black;
            }
        }
        .news:first-child {
            @apply pl-0;
        }
        .news:last-child {
            @apply pr-0 border-r-0;
        }
    }
}
</style>
